module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "selection",
    class: {
      'is-show': _vm.isShow
    }
  }, [_c('div', {
    staticClass: "selection-wrap",
    on: {
      "click": function($event) {
        _vm.showSelection(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "selection-content"
  }, [_c('checklist', {
    attrs: {
      "required": true,
      "options": _vm.list,
      "max": 1
    },
    on: {
      "on-change": function($event) {
        _vm.change()
      }
    },
    model: {
      value: (_vm.checkedVal),
      callback: function($$v) {
        _vm.checkedVal = $$v
      },
      expression: "checkedVal"
    }
  }), _vm._v(" "), (_vm.list.length === 0) ? _c('p', {
    staticClass: "text-align-center font-size-m"
  }, [_vm._v("无可选列表")]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac5523d8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/Index_selection/index.vue
// module id = 922
// module chunks = 1